import React from '@wordpress/element'
import { hydrate, render } from 'react-dom';
import { FrontComponent } from './save'
import { name } from './block.json';
import { getBlockSelector } from '../utils';
import "keen-slider/keen-slider.min.css"

export const init = () => {
  const items = document.querySelectorAll(getBlockSelector(name));
  for ( let hero of items) {
    const attrs = JSON.parse(hero.previousElementSibling.innerText);

    if (hero.children.length === 0) {
      render(<FrontComponent attributes={attrs} />, hero);
    } else {
      hydrate(<FrontComponent attributes={attrs} />, hero);
    }

  }
}
